import { useEffect, useState } from "react";
import { useGetPermission } from "../callApis/gertPermissions";
import { useDispatch } from "react-redux";
import { permissionClearData } from "../../../store/permissions/actions";
export var usePermissionData = function () {
    var dispatch = useDispatch();
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState([]), permissionList = _b[0], setPermissionList = _b[1];
    useEffect(function () {
        setTrigger(true);
    }, []);
    var _c = useGetPermission(trigger, 1, 1000, ""), responsePermission = _c.responsePermission, loadingPermission = _c.loadingPermission, errorPermission = _c.errorPermission;
    useEffect(function () {
        if ((responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.length) > 0) {
            var newList = responsePermission.map(function (p) { return ({
                id: p.id,
                name: p.name,
                description: p.description,
                type: p.type,
            }); });
            setPermissionList(newList);
            dispatch(permissionClearData());
        }
    }, [responsePermission]);
    return { permissionList: permissionList, loadingPermission: loadingPermission, errorPermission: errorPermission };
};
